import { CustomerRFQProtocolRules } from '@src/containers/Dealer/CustomerRFQProtocolRules';
import type { CustomerRFQProtocolRulesPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerRFQProtocolRulesPanel({ api, params }: LayoutPanelProps<CustomerRFQProtocolRulesPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-rfq-protocol-rules-panel"
    >
      <CustomerRFQProtocolRules />
    </EntityAdminPanelShell>
  );
}
